import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  geographyData: [],
  pagination: {
    currentPage: 1,
    pageSize: 10, 
    total: 0,
  },
};

const geographyAnalyticsSlice = createSlice({
  name: "geographyAnalytics",
  initialState,
  reducers: {
    fetchGeographyData: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchGeographyDataSuccess: (state, action) => {
      const { data } = action.payload;
      state.loading = false;
      state.geographyData = Array.isArray(data) ? data : [];
      state.pagination.total = Array.isArray(data) ? data.length : 0;
    },
    fetchGeographyDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.geographyData = [];
      state.pagination.total = 0;
    },
    setPagination: (state, action) => {
      const { currentPage, pageSize } = action.payload;
      state.pagination.currentPage = currentPage || state.pagination.currentPage;
      state.pagination.pageSize = pageSize || state.pagination.pageSize;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
      state.pagination.currentPage = 1; 
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    resetPagination: (state) => {
      state.pagination.currentPage = 1;
      state.pagination.pageSize = 10;
    },
  },
});

export const { actions, reducer } = geographyAnalyticsSlice;
export const sliceKey = geographyAnalyticsSlice.name;